export enum PayoutRequisitesAutomationStatus {
  Active = 'active', // manual
  Automation = 'automation',
  Inactive = 'inactive',
}
